import { useTranslation } from "react-i18next";
import {
  PRE_ACTIVATION_FIELD_AGENCY_NAME,
  PRE_ACTIVATION_FIELD_BUSINESS_NAME,
  PRE_ACTIVATION_FIELD_EMAIL,
  PRE_ACTIVATION_FIELD_FULL_NAME,
  PRE_ACTIVATION_FIELD_JOB_TITLE,
  PRE_ACTIVATION_FIELD_WEBSITE_URL,
  PRE_ACTIVATION_FIELD_WHATSAPP,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME,
  PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME,
  PRE_ACTIVATION_PLACEHOLDER_EMAIL,
  PRE_ACTIVATION_PLACEHOLDER_FULL_NAME,
  PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE,
  PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL,
  PRE_ACTIVATION_PLACEHOLDER_WHATSAPP,
} from "../../../i18n/keysTranslations";
import FieldBlock from "../components/FieldBlock";
import FieldLabel from "../components/FieldLabel";
import IntakeTextField from "../../../components/Form/IntakeTextField";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";

const ContactSection = ({ control, errors, readOnly, isAgency = false }) => {
  const { t } = useTranslation();

  const businessNameLabelKey = isAgency
    ? PRE_ACTIVATION_FIELD_AGENCY_NAME
    : PRE_ACTIVATION_FIELD_BUSINESS_NAME;
  const businessNamePlaceholderKey = isAgency
    ? PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME
    : PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME;

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <FieldBlock>
        <FieldLabel
          htmlFor="fullName"
          text={t(PRE_ACTIVATION_FIELD_FULL_NAME)}
          required
        />
        <IntakeTextField
          name="fullName"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_FULL_NAME)}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="email"
          text={t(PRE_ACTIVATION_FIELD_EMAIL)}
          required
        />
        <IntakeTextField
          name="email"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_EMAIL)}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="businessName"
          text={t(businessNameLabelKey)}
          required
        />
        <IntakeTextField
          name="businessName"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={t(businessNamePlaceholderKey)}
          variant="outlined"
        />
      </FieldBlock>

      {!isAgency ? (
        <>
          <FieldBlock>
            <FieldLabel
              htmlFor="jobTitle"
              text={t(PRE_ACTIVATION_FIELD_JOB_TITLE)}
              required
            />
            <IntakeTextField
              name="jobTitle"
              control={control}
              rules={{}}
              errors={errors}
              fullWidth
              readOnly={readOnly}
              placeholder={t(PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE)}
              variant="outlined"
            />
          </FieldBlock>

          <FieldBlock>
            <FieldLabel
              htmlFor="whatsApp"
              text={t(PRE_ACTIVATION_FIELD_WHATSAPP)}
              required
            />
            <IntakeTextField
              name="whatsApp"
              control={control}
              rules={{}}
              errors={errors}
              fullWidth
              readOnly={readOnly}
              placeholder={t(PRE_ACTIVATION_PLACEHOLDER_WHATSAPP)}
              variant="outlined"
            />
          </FieldBlock>

          <FieldBlock>
            <FieldLabel
              htmlFor="websiteUrl"
              text={t(PRE_ACTIVATION_FIELD_WEBSITE_URL)}
            />
            <IntakeTextField
              name="websiteUrl"
              control={control}
              rules={{}}
              errors={errors}
              fullWidth
              readOnly={readOnly}
              placeholder={t(PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL)}
              variant="outlined"
            />
          </FieldBlock>
        </>
      ) : null}
    </ReadOnlySectionGrid>
  );
};

export default ContactSection;
